// src/components/Dashboard/RefreshNotificationButton.tsx
// Button that appears when socket notifications signal pending dashboard updates.
// Rendered conditionally — only visible when hasPendingUpdates is true.

import React from 'react';
// RefreshCw import removed (unused)
import { cn } from '@/lib/cn';

interface RefreshNotificationButtonProps {
  hasPendingUpdates: boolean;
  pendingCount?: number;
  onClick: () => void;
  className?: string;
  message?: string;
  style?: React.CSSProperties;
}

export const RefreshNotificationButton: React.FC<RefreshNotificationButtonProps> = ({
  hasPendingUpdates,
  pendingCount: _pendingCount = 0,
  onClick,
  className,
  message = 'Your dashboard has changed, click here to refresh',
  style,
}) =>
{
  if (!hasPendingUpdates) return null;

  return (
    <button
      onClick={onClick}
      className={cn(
        'fixed z-[200] left-1/2 -translate-x-1/2',
        'flex items-center gap-1.5 px-3 py-2 text-xs font-medium',
        'bg-[#62aacb] text-white rounded-md shadow-md',
        'hover:bg-[#4e95b8] active:scale-95 transition-all duration-150',
        className,
      )}
      style={{ top: '9rem', ...style }}
      title="New updates available — click to refresh"
    >
      <span>{message}</span>
    </button>
  );
};
